import { SIDEBAR_COLLAPSE, SIDEBAR_STATE, SET_DASHBOARD_FILTER } from 'constants/ActionTypes';

function SidebarCollapse(payload) {
  return { type: SIDEBAR_COLLAPSE, payload };
}

function CollapseSidebar(payload) {
  return { type: SIDEBAR_STATE, payload };
}

function SetDashboardFilter(payload) {
  return { type: SET_DASHBOARD_FILTER, payload };
}

export { SidebarCollapse, CollapseSidebar, SetDashboardFilter };
